import React from 'react';
import PropTypes from 'prop-types';
import { Edit2 } from 'react-feather';

const EditLessonButton = ({ editLessonSectionUrl }) => {
  if (!editLessonSectionUrl) {
    return null;
  }

  return (
    <div className="LessonHeader-editButton ml-8">
      <a
        href={editLessonSectionUrl}
        rel="noopener noreferrer"
        target="_blank"
        data-toggle="tooltip"
        data-title={t('lessons.sections.edit')}
        data-placement="bottom"
        aria-label={t('lessons.sections.edit')}
      >
        <Edit2 size="1.75rem" />
      </a>
    </div>
  );
};

EditLessonButton.propTypes = {
  editLessonSectionUrl: PropTypes.string,
};

export default EditLessonButton;
